export const CoverType = {
  Blank: 100,
  Customer: 200
}
